module.exports = __webpack_public_path__ + "img/knex.8909304d.png";